import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const survivorshipCohortSearchSchema = z.object({
  search: z.coerce.string().optional().catch(""),
  status: z
    .enum(["all", "not_enrolled", "active", "paused", "ended"])
    .catch("all"),
  page: z.coerce.number().catch(1),
  // Bulk-enroll mode — swaps the cohort table for the bulk-enroll flow.
  bulk: z.coerce.boolean().catch(false),
})

export const Route = createFileRoute("/_app/oncology/survivorship/")({
  validateSearch: (search: SearchSchemaInput) =>
    survivorshipCohortSearchSchema.parse(search),
})
